import {
  ButtonGroup,
  Button,
  Tooltip,
  OverlayTrigger,
}from 'react-bootstrap';

var React = require('react');
var FontAwesome = require('react-fontawesome');

class ListView extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      index: 0,
    }
  }

  nextItem = () => {
    this.changeItem(1);
  }

  changeItem = (incr) => {
    this.setState((prevState, prevProps) => {

      const inBounds = (prevState.index + incr >= 0 && prevState.index + incr < this.props.progressList.length)

      return({
          index: (inBounds) ? prevState.index + incr : prevState.index,
      })
    })
  }

  prevItem = () => {
    this.changeItem(-1);
  }

  render() {

    const childrenToRender = React.Children.map(this.props.children,
     (child) => React.cloneElement(child, {
       //here you pass props to children

      },
     )
    );

    if (!this.props.isListView){
      //Return single item
      const currItem = this.props.progressList[this.state.index];
      const currChild = childrenToRender.findIndex( x => x.props.item.word === currItem.word);

      return(
        <div style={styles.singleMode} >
          {childrenToRender[currChild]}
          <NavButtons
            prevItem = {this.prevItem}
            nextItem = {this.nextItem}
          />
        </div>
      )
    }else{
      //Return list items
      return(
        <div>
          {childrenToRender}
        </div>
      )
    }
  }
}

const tooltipNext = (
  <Tooltip id="tooltip">Click this button to go to the next item</Tooltip>
)

const tooltipPrev = (
  <Tooltip id="tooltip">Click this button to go to the previous item</Tooltip>
)

let NavButtons = ({nextItem, prevItem}) => (
  <div>

    <ButtonGroup>
      <OverlayTrigger placement="top" overlay={tooltipPrev}>
       <Button
         bsStyle="primary"
         onClick={prevItem}
        >
          <FontAwesome
            name="chevron-left"
            inverse={true}
            size="2x"
          />
       </Button>
      </OverlayTrigger>
       <OverlayTrigger placement="top" overlay={tooltipNext}>
         <Button
           bsStyle="primary"
           onClick={nextItem}
          >
           <FontAwesome
             name="chevron-right"
             inverse={true}
             size="2x"
           />
         </Button>
       </OverlayTrigger>
    </ButtonGroup>
    <div style={styles.navButtonFiller}></div>
  </div>
)

const styles = {
  navButtonsTitle: {
    marginBottom: '1rem',
    textAlign: 'center',
    fontSize: '20px',
    fontWeight: '400',
    color: 'grey',
  },
  navButtonFiller: {
    height: '100px',
  },
  singleMode: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }
}

export default ListView;



// WEBPACK FOOTER //
// ./src/comp/Activities/ListView.js